import { useEffect, useState } from "react";
import { adminListMessages, adminUpdateMessage, adminDeleteMessage } from "@/lib/api";
import { Mail, MailOpen, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function AdminMessages() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = () => { setLoading(true); adminListMessages().then(setItems).finally(() => setLoading(false)); };
  useEffect(load, []);

  const toggle = async (m) => { await adminUpdateMessage(m.id, !m.read); setItems((p) => p.map((x) => x.id === m.id ? { ...x, read: !m.read } : x)); };
  const remove = async (m) => { if (!window.confirm("Delete this message?")) return; await adminDeleteMessage(m.id); toast("Deleted"); load(); };

  return (
    <div className="max-w-3xl">
      <h1 className="mb-1 font-serif-latin text-3xl text-ink">Messages</h1>
      <p className="mb-6 text-sm text-ink-3">{loading ? "…" : `${items.filter((x) => !x.read).length} unread · ${items.length} total`}</p>
      {loading ? <p className="py-16 text-center text-ink-3">…</p> : items.length === 0 ? (
        <div className="border border-line bg-surface p-16 text-center text-ink-3">No messages yet.</div>
      ) : (
        <div className="space-y-3">
          {items.map((m) => (
            <div key={m.id} data-testid={`message-${m.id}`} className={`border p-5 ${m.read ? "border-line bg-surface" : "border-[var(--gold-muted)]/50 bg-[rgba(176,141,87,0.05)]"}`}>
              <div className="flex items-start justify-between gap-3">
                <div>
                  <p className="font-serif-latin text-lg text-ink">{m.subject || "(no subject)"}</p>
                  <p className="text-sm text-ink-2">{m.name} · <a href={`mailto:${m.email}`} className="text-saffron">{m.email}</a></p>
                </div>
                <div className="flex shrink-0 items-center gap-2">
                  <button onClick={() => toggle(m)} title={m.read ? "Mark unread" : "Mark read"} className="p-2 text-ink-3 hover:text-saffron">{m.read ? <MailOpen className="h-4 w-4" /> : <Mail className="h-4 w-4" />}</button>
                  <button onClick={() => remove(m)} className="p-2 text-ink-3 hover:text-[var(--saffron-dark)]"><Trash2 className="h-4 w-4" /></button>
                </div>
              </div>
              <p className="mt-3 whitespace-pre-line text-[15px] leading-relaxed text-ink-2">{m.message}</p>
              <p className="mt-3 text-xs text-ink-3">{m.created_at?.slice(0, 16).replace("T", " ")}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
